import {
  APIgetPeople,
  APIupdateFace,
  APIdeletePerson,
  APIhideFace,
  APIunhideFace,
} from '../api/Faces';

import { eventDispatch } from '../helpers/Events';

export const SET_PEOPLE_LOADING = 'SET_PEOPLE_LOADING';
export const SET_PEOPLE_END = 'SET_PEOPLE_END';
export const GET_PEOPLE = 'GET_PEOPLE';
export const SET_PEOPLE_TOTAL = 'SET_PEOPLE_TOTAL';
export const CLEAR_PEOPLE = 'CLEAR_PEOPLE';
export const SET_PEOPLE_PARAMS = 'SET_PEOPLE_PARAMS';
export const CLEAR_PEOPLE_PARAMS = 'CLEAR_PEOPLE_PARAMS';
export const SET_SELECTED_PEOPLE = 'SET_SELECTED_PEOPLE';
export const ADD_SELECTED_PERSON = 'ADD_SELECTED_PERSON';
export const ADD_SELECTED_PEOPLE = 'ADD_SELECTED_PEOPLE';
export const REMOVE_SELECTED_PERSON = 'REMOVE_SELECTED_PERSON';
export const CLEAR_SELECTED_PEOPLE = 'CLEAR_SELECTED_PEOPLE';
export const SELECT_PERSON = 'SELECT_PERSON';
export const REMOVE_PERSON = 'REMOVE_PERSON';
export const UPDATE_PEOPLE_ON_PEOPLE_LIST = 'UPDATE_PEOPLE_ON_PEOPLE_LIST';
export const REMOVE_PERSON_FROM_PEOPLE_LIST = 'REMOVE_PERSON_FROM_PEOPLE_LIST';

export const setPeopleLoading = status => ({
  type: SET_PEOPLE_LOADING,
  loading: status,
});

export const setPeopleEnd = status => ({
  type: SET_PEOPLE_END,
  end: status,
});

export const getPeople = people => ({
  type: GET_PEOPLE,
  people,
});

export const setPeopleTotal = total => ({
  type: SET_PEOPLE_TOTAL,
  total,
});

export const clearPeople = (hasSearch = false) => ({
  type: CLEAR_PEOPLE,
  hasSearch,
});

export const setPeopleParams = params => ({
  type: SET_PEOPLE_PARAMS,
  params,
});

export const clearPeopleParams = () => ({
  type: CLEAR_PEOPLE_PARAMS,
});

export const setSelectedPeople = people => ({
  type: SET_SELECTED_PEOPLE,
  people,
});

export const addSelectedPerson = person => ({
  type: ADD_SELECTED_PERSON,
  person,
});

export const addSelectedPeople = people => ({
  type: ADD_SELECTED_PEOPLE,
  people,
});

export const removeSelectedPerson = personUuid => ({
  type: REMOVE_SELECTED_PERSON,
  personUuid,
});

export const clearSelectedPeople = () => ({
  type: CLEAR_SELECTED_PEOPLE,
});

export const removePerson = (personUuid) => ({
  type: REMOVE_PERSON,
  personUuid,
});

export const updatePeopleOnPeopleList = (people) => ({
  type: UPDATE_PEOPLE_ON_PEOPLE_LIST,
  people,
});

export const removePersonFromPeopleList = personUuid => ({
  type: REMOVE_PERSON_FROM_PEOPLE_LIST,
  personUuid,
});

export const fetchPeople = () => (dispatch, getState) => {
  const state = getState();
  if (state.People.end) {
    return false;
  }

  dispatch(setPeopleLoading(true));

  const params = { ...state.People.params };
  let offset = 0;
  if (params.page * params.perPage > state.People.people.length) {
    offset = state.People.people.length;
  }
  params.order_by = params.orderBy;
  params.per_page = params.perPage;
  delete params.orderBy;
  delete params.perPage;

  params.page += 1;

  return APIgetPeople({
    ...(offset > 0) && { offset },
    ...params,
    ...state.Search,
  })
    .then((response) => {
      dispatch(getPeople(response.data));
      if (response.meta.current_page >= response.meta.last_page) {
        dispatch(setPeopleEnd(true));
      }
      dispatch(setPeopleParams({ page: response.meta.current_page }));
      dispatch(setPeopleTotal(response.meta.total));
      dispatch(setPeopleLoading(false));
      return response;
    })
    .catch(error => (error));
};

export const deletePerson = (personUuid) => (dispatch) => (
  APIdeletePerson(personUuid)
    .then((response) => {
      dispatch(removePerson(personUuid));
      return response.data;
    })
);

export const clearFacePerson = faceUuid => (
  APIupdateFace({ uuid: faceUuid, person_uuid: null })
    .then((response) => {
      eventDispatch('faceUpdated', response);
      return response.data;
    })
);

export const hideFace = faceUuid => (
  APIhideFace(faceUuid)
    .then((response) => {
      eventDispatch('faceUpdated', response);
      return response.data;
    })
);

export const unhideFace = faceUuid => (
  APIunhideFace(faceUuid)
    .then((response) => {
      eventDispatch('faceUpdated', response);
      return response.data;
    })
);
